// getOne
// change -> allow edit email
import { ACTIONS } from '../../Models/ENUM';
import CONQUER from '../CONQUER';
import Storage from '../UTILS/Storage';
import User from './User';
import LOG, { log } from '../../UTIL/LOG';
import AvatarInstance from '../AVATAR/AvatarInstance';
import DATE from '../../UTIL/DATE';
import RANDOM from '../../UTIL/RANDOM';
import USERNAME from '../../Core/USER/USERNAME';
import { param } from 'jquery';
import { connected } from 'process';

class Username 
{
    private conquer: CONQUER;

    public constructor(instance:CONQUER) 
    {
        this.conquer = instance;
    }

    public async get( username: string ) : Promise<any>
    {
        let response = await this.conquer.do( ACTIONS.USERNAME_GET, { username, similar: true });
        return Promise.resolve( response );
    }

    public async getFromAvatarID( avatarID: string) : Promise<any>
    {
        let response = await this.conquer.do( ACTIONS.USERNAME_GETONE, { avatarID:avatarID });
        return Promise.resolve( response ? response.username : null );
    }

    public async getOne( username: string ): Promise<any> 
    {
        let response : any = await this.conquer.do( ACTIONS.USERNAME_GETONE, { username } ); 
        return Promise.resolve(response);
    }
 
};


export default Username;